import _toConsumableArray from "/home/renato/github/renato145.github.io/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _inherits from "/home/renato/github/renato145.github.io/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/renato/github/renato145.github.io/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/renato/github/renato145.github.io/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _classCallCheck from "/home/renato/github/renato145.github.io/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/renato/github/renato145.github.io/node_modules/@babel/runtime/helpers/esm/createClass.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __classPrivateFieldSet = this && this.__classPrivateFieldSet || function (receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};

var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function (receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};

var _Optimizer_modified;

import { GraticuleNode } from './graticule';
import { SequenceNode } from './sequence';
import { SourceNode } from './source';
/**
 * Whether this dataflow node is the source of the dataflow that produces data i.e. a source or a generator.
 */

export function isDataSourceNode(node) {
  return node instanceof SourceNode || node instanceof GraticuleNode || node instanceof SequenceNode;
}
/**
 * Abstract base class for Dataflow optimizers.
 * Contains only mutation handling logic. Subclasses need to implement iteration logic.
 */

export var Optimizer = /*#__PURE__*/function () {
  function Optimizer() {
    _classCallCheck(this, Optimizer);

    _Optimizer_modified.set(this, void 0);

    __classPrivateFieldSet(this, _Optimizer_modified, false, "f");
  } // Once true, #modified is never set to false


  _createClass(Optimizer, [{
    key: "setModified",
    value: function setModified() {
      __classPrivateFieldSet(this, _Optimizer_modified, true, "f");
    }
  }, {
    key: "modifiedFlag",
    get: function get() {
      return __classPrivateFieldGet(this, _Optimizer_modified, "f");
    }
  }]);

  return Optimizer;
}();
_Optimizer_modified = new WeakMap();
/**
 * Starts from a node and runs the optimization function (the "run" method) upwards to the root,
 * depending on the continue and modified flag values returned by the optimization function.
 */

export var BottomUpOptimizer = /*#__PURE__*/function (_Optimizer) {
  _inherits(BottomUpOptimizer, _Optimizer);

  var _super = _createSuper(BottomUpOptimizer);

  function BottomUpOptimizer() {
    _classCallCheck(this, BottomUpOptimizer);

    return _super.apply(this, arguments);
  }

  _createClass(BottomUpOptimizer, [{
    key: "getNodeDepths",
    value:
    /**
     * Compute a map of node depths that we can use to determine a topological sort order.
     */
    function getNodeDepths(node, depth, depths) {
      depths.set(node, depth);

      var _iterator = _createForOfIteratorHelper(node.children),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var child = _step.value;
          this.getNodeDepths(child, depth + 1, depths);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return depths;
    }
    /**
     * Run the optimizer on all nodes starting from the leaves.
     */

  }, {
    key: "optimize",
    value: function optimize(node) {
      var depths = this.getNodeDepths(node, 0, new Map());

      var topologicalSort = _toConsumableArray(depths.entries()).sort(function (a, b) {
        return b[1] - a[1];
      });

      var _iterator2 = _createForOfIteratorHelper(topologicalSort),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var tuple = _step2.value;
          this.run(tuple[0]);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return this.modifiedFlag;
    }
  }]);

  return BottomUpOptimizer;
}(Optimizer);
/**
 * The optimizer function (the "run" method), is invoked on the given node and then continues recursively.
 */

export var TopDownOptimizer = /*#__PURE__*/function (_Optimizer2) {
  _inherits(TopDownOptimizer, _Optimizer2);

  var _super2 = _createSuper(TopDownOptimizer);

  function TopDownOptimizer() {
    _classCallCheck(this, TopDownOptimizer);

    return _super2.apply(this, arguments);
  }

  _createClass(TopDownOptimizer, [{
    key: "optimize",
    value:
    /**
     * Run the optimizer depth first on all nodes starting from the roots.
     */
    function optimize(node) {
      this.run(node);

      var _iterator3 = _createForOfIteratorHelper(node.children),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var child = _step3.value;
          this.optimize(child);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return this.modifiedFlag;
    }
  }]);

  return TopDownOptimizer;
}(Optimizer);